import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject, catchError } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { repOsjupdate } from '../../@core/interfaces/common/users'
@Injectable({
  providedIn: 'root',
})
export class TypesServices extends BehaviorSubject<any[]> {
  constructor(private _http: HttpClient) {
    super([])
  }
  getActiveTypeStatelist(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetAllActiveStates`)
      .pipe(catchError(this.handleError))
  }
  getCompleteStatelist(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetAllStates`)
      .pipe(catchError(this.handleError))
  }
  getInvestmentTypelist(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/Getinvestmentlist`)
      .pipe(catchError(this.handleError))
  }
  getInvestmentObjectlist(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/Getinvestmentobject`)
      .pipe(catchError(this.handleError))
  }
  getLiquidObjectlist(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetLiquidList`)
      .pipe(catchError(this.handleError))
  }
  gettimeZoneObjectlist(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetTimeZonelist`)
      .pipe(catchError(this.handleError))
  }
  getMaskObjectlist(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetTaxIDMask`)
      .pipe(catchError(this.handleError))
  }
  getLicenseList(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetLicenseList`)
      .pipe(catchError(this.handleError))
  }
  getNoteTypes(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetNoteTypes`)
      .pipe(catchError(this.handleError))
  }
  getProTypes(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetProTypes`)
      .pipe(catchError(this.handleError))
  }
  getFirmTypes(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetFirmTypes`)
      .pipe(catchError(this.handleError))
  }
  getApprovedSocialMedia(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetApprovedSocialMedia`)
      .pipe(catchError(this.handleError))
  }
  getSubscription(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetSubscription`)
      .pipe(catchError(this.handleError))
  }
  getAssistantLookups(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetAssistantLookups`)
      .pipe(catchError(this.handleError))
  }
  getTypesOfFirms(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetTypesOfFirms`)
      .pipe(catchError(this.handleError))
  }
  getBank(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetBank`)
      .pipe(catchError(this.handleError))
  }
  getBrokerFirm(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetBrokerFirm`)
      .pipe(catchError(this.handleError))
  }
  getOfficeType(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetOfficeType`)
      .pipe(catchError(this.handleError))
  }
  getRegion(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetRegion`)
      .pipe(catchError(this.handleError))
  }
  getCRDBranchType(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetCRDBranchType`)
      .pipe(catchError(this.handleError))
  }
  getBranch(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetBranch`)
      .pipe(catchError(this.handleError))
  }
  getCRDBranch(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Types/GetCRDBranch`)
      .pipe(catchError(this.handleError))
  }
  getEvents(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetEvents`)
      .pipe(catchError(this.handleError))
  }
  getActiveEvents(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetActiveEvents`)
      .pipe(catchError(this.handleError))
  }
  getActiveEventsForUser(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetActiveEventsForUser`)
      .pipe(catchError(this.handleError))
  }
  getEventsForUser(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetEventsForUser`)
      .pipe(catchError(this.handleError))
  }
  markEventAsRead(eventId: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/MarkEventAsRead`, eventId)
      .pipe(catchError(this.handleError))
  }
  markAllEventsAsRead(): Observable<any> {
    return this._http
      .post<any>(`/api/Types/MarkAllEventsAsRead`, {})
      .pipe(catchError(this.handleError))
  }
  getProductNames(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetProductNames`)
      .pipe(catchError(this.handleError))
  }
  getSponsors(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetSponsors`)
      .pipe(catchError(this.handleError))
  }
  getSponsorsForProductClassFour(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetSponsorsForProductClassFour`)
      .pipe(catchError(this.handleError))
  }
  getImos(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetImos`)
      .pipe(catchError(this.handleError))
  }
  getProductTypes(): Observable<any[]> {
    return this._http
      .get<any[]>('/api/Types/productTypelist')
      .pipe(catchError(this.handleError))
  }
  getMarketingTypes(): Observable<any[]> {
    return this._http
      .get<any[]>('/api/Types/GetMarketingTypes')
      .pipe(catchError(this.handleError))
  }
  getMarketingEntityTypes(): Observable<any[]> {
    return this._http
      .get<any[]>('/api/Types/GetMarketingEntityTypes')
      .pipe(catchError(this.handleError))
  }
  getMarketingDistributionMethodTypes(): Observable<any[]> {
    return this._http
      .get<any[]>('/api/Types/GetMarketingDistributionMethodTypes')
      .pipe(catchError(this.handleError))
  }
  getMarketingDistributionQuantityTypes(): Observable<any[]> {
    return this._http
      .get<any[]>('/api/Types/GetMarketingDistributionQuantityTypes')
      .pipe(catchError(this.handleError))
  }
  getMarketingStatusTypes(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetMarketingStatusTypes`)
      .pipe(catchError(this.handleError))
  }
  getStatusCodeTypes(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetStatusCodeTypes`)
      .pipe(catchError(this.handleError))
  }
  submitClientInfo(cli: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Clients/clientInfoSubmited`, cli)
      .pipe(catchError(this.handleError))
  }
  submitClientTransactionInfo(cli: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Clients/clientblottrans`, cli)
      .pipe(catchError(this.handleError))
  }
  DeleteTransactions(pramblot: any): Observable<object> {
    return this._http
      .post<any[]>(`/api/Blotter/deleteTransactionsby`, pramblot)
      .pipe(catchError(this.handleError))
  }
    DeleteTransactionsaccount(pramblot: any): Observable<object> {
    return this._http
      .post<any[]>(`/api/Clients/deleteTransactionsby`, pramblot)
      .pipe(catchError(this.handleError))
  }
  submitAssistantLevelUpdate(assistantLevel: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitAssistantLevelUpdate`, assistantLevel)
      .pipe(catchError(this.handleError))
  }
  submitFirmTypeUpdate(firmType: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitFirmTypeUpdate`, firmType)
      .pipe(catchError(this.handleError))
  }
  submitLicenseUpdate(license: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitLicenseUpdate`, license)
      .pipe(catchError(this.handleError))
  }
  submitNoteTypeUpdate(noteType: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitNoteTypeUpdate`, noteType)
      .pipe(catchError(this.handleError))
  }
  submitProTypeUpdate(proType: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitProTypeUpdate`, proType)
      .pipe(catchError(this.handleError))
  }
  submitApprovedSocialMediaUpdate(approvedSocialMedia: any): Observable<any> {
    return this._http
      .post<any>(
        `/api/Types/SubmitApprovedSocialMediaUpdate`,
        approvedSocialMedia,
      )
      .pipe(catchError(this.handleError))
  }
  submitStateUpdate(state: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitStateUpdate`, state)
      .pipe(catchError(this.handleError))
  }
  submitSubscriptionUpdate(subscription: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitSubscriptionUpdate`, subscription)
      .pipe(catchError(this.handleError))
  }
  submitBankUpdate(bank: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitBankUpdate`, bank)
      .pipe(catchError(this.handleError))
  }
  submitBrokerFirmUpdate(brokerFirm: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitBrokerFirmUpdate`, brokerFirm)
      .pipe(catchError(this.handleError))
  }
  submitOfficeTypeUpdate(officeType: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitOfficeTypeUpdate`, officeType)
      .pipe(catchError(this.handleError))
  }
  submitRegionUpdate(region: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitRegionUpdate`, region)
      .pipe(catchError(this.handleError))
  }
  submitCRDBranchTypeUpdate(crdBranchType: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitCRDBranchTypeUpdate`, crdBranchType)
      .pipe(catchError(this.handleError))
  }
  submitBranchUpdate(branch: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitBranchUpdate`, branch)
      .pipe(catchError(this.handleError))
  }
  submitTypeOfFirmUpdate(typeOfFirm: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitTypeOfFirmUpdate`, typeOfFirm)
      .pipe(catchError(this.handleError))
  }
  submitCRDBranchUpdate(crdBranch: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitCRDBranchUpdate`, crdBranch)
      .pipe(catchError(this.handleError))
  }
  submitEventUpdate(event: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitEventUpdate`, event)
      .pipe(catchError(this.handleError))
  }
  submitProductNameUpdate(productName: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitProductNameUpdate`, productName)
      .pipe(catchError(this.handleError))
  }
  submitSponsorUpdate(sponsor: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitSponsorUpdate`, sponsor)
      .pipe(catchError(this.handleError))
  }
  submitImoUpdate(imo: any): Observable<any> {
    return this._http
      .post<any>(`/api/Types/SubmitImoUpdate`, imo)
      .pipe(catchError(this.handleError))
  }
  returnnavibyrole(): Observable<any> {
    return this._http
      .get<any>(`/api/Types/getnavlist`)
      .pipe(catchError(this.handleError))
  }
  OSJUpdateRep(cli: repOsjupdate): Observable<object[]> {
    const param = { rep: cli }
    return this._http
      .post<repOsjupdate[]>(`/api/Rep/osjupdateRep`, param)
      .pipe(catchError(this.handleError))
  }
  private handleError(error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
}
